<!-- Bookmarks -->

<li class="fdm-sidebar-scene-layer header" *ngIf="plugin && controller && controller.show" [ngClass]="{'hasItems':controller.items.length,'isOpen':controller.open}">

    <div class="fdm-layer-tools" *ngIf="controller && controller.bucketActions && controller.bucketActions.length">
        <fa-icon *ngFor="let action of controller.bucketActions" class="fdm-silent-icon fdm-layer-icon float-right" [icon]="action.icon" (click)="controller.bucketAction(action)" [matTooltip]="action.tooltip | translate"></fa-icon>
    </div>
    <div class="fdm-layer-title fdm-link fdm-layer-section-title" (click)="controller.open = !controller.open" id="tab-bookmark">

        <!-- Show bookmarks-->
        <fa-icon *ngIf="!controller.open" [fixedWidth]="true" class="fdm-silent-icon" icon="caret-right" matTooltip="{{'PLUGINS.BUCKET.TOUR_GUIDE.SHOW' | translate}}"></fa-icon>
        
        <!-- Hide bookmarks-->
        <fa-icon *ngIf="controller.open" [fixedWidth]="true" class="fdm-silent-icon" icon="caret-down" matTooltip="{{'PLUGINS.BUCKET.TOUR_GUIDE.HIDE' | translate}}"></fa-icon>
        {{ textual + 'LABEL' | translate }} 
        <i *ngIf="controller.items">{{ controller.items.length }}</i>
        <i *ngIf="!controller.items">0</i>
    </div>
    <div class="clearfix"></div>
</li>

<li class="fdm-sidebar-scene-layer" *ngIf="controller.open" [@slideInOut] style="margin-bottom:10px;">

    <div>

        <div *ngIf="!controller.items || !controller.items.length" class="alert clearfix" style="color:orange;">
            {{ textual + 'NONE' | translate }} 
        </div>

        <table class="fdm-sidebar-table-list" *ngIf="controller.items" cdkDropList (cdkDropListDropped)="controller.itemDropped($event)">
            <tr *ngFor="let item of controller.items" [class.selected]="controller.selectedItem == item" cdkDragLockAxis="y" cdkDrag>
                <td class="fdm-linked" style="padding:2px;width:15px;text-align:right;">
                    <fa-icon [icon]="item.icon" ></fa-icon>
                </td>
                <td class="fdm-linked" style="padding:2px;" (click)="controller.itemSelect(item);">
                    {{ item.label }}
                    <fa-icon *ngFor="let action of controller.itemActions" class="fdm-linked fdm-layer-icon float-right" [icon]="action.icon" (click)="controller.itemAction(item,action);$event.stopPropagation();" [matTooltip]="action.tooltip | translate"></fa-icon>
                </td>
            </tr>
        </table>

    </div>

</li>


<div [title]="myIndex()">
    <div *ngIf="controller && controller.selectedItem" class="bucket-info" [style.right]="myRight()">
        
        <fa-icon class="fdm-silent-icon fdm-linked float-right closing" icon="times" (click)="controller.itemUnselect()"></fa-icon>
        <fa-icon class="fdm-silent-icon fdm-linked float-right" [icon]="controller.selectedEdit ? 'save' : 'edit'" (click)="controller.saveToObject();controller.selectedEdit = !controller.selectedEdit;"></fa-icon>
        
        <ng-container *ngIf="!controller.selectedEdit">
            <h2 *ngIf="controller.selectedItem.label">{{ controller.selectedItem.label }}</h2>
            <p *ngIf="controller.selectedItem.desc">{{ controller.selectedItem.desc }}</p>    
        </ng-container>
    
        <div style="font-size:14px;" *ngIf="controller.selectedEdit">
            <input type="text" style="width:80%;" [(ngModel)]="controller.selectedItem.label" />
            <textarea style="width:100%;height:120px;margin-top:5px;" [(ngModel)]="controller.selectedItem.desc">{{ controller.selectedItem.desc }}</textarea>
        </div>
    
        <nav *ngIf="controller.showNavigation">
            <button *ngIf="controller.hasPrevious(controller.selectedItem)" class="fdm-button float-left fdm-guide-b" mat-flat-button style="color:#666;border:solid 1px #ddd;" (click)="controller.previous(controller.selectedItem)">
                <fa-icon icon="angle-double-left"></fa-icon> {{ 'MAP.GUIDES.PREVIOUS' | translate }}
            </button>
            <button *ngIf="controller.hasNext(controller.selectedItem)" class="fdm-button float-right fdm-guide-b" mat-flat-button color="accent" (click)="controller.next(controller.selectedItem)">
                {{ 'MAP.GUIDES.NEXT' | translate }} <fa-icon icon="angle-double-right"></fa-icon>
            </button>
        </nav>
    </div>
</div>
